export default __STORYBOOKADDONS__;
const { addons, types, mockChannel } = __STORYBOOKADDONS__;
export { addons, types, mockChannel };